import { defaultApi, publicApi } from "@/config/httpClient";
import { getLanguageHeaders } from "@/config/i18n";
import {
  AppointmentDto, AppointmentType, CancelAppointmentDto,
  CreateAppointmentDto,
  ObjectStatus, ResultAppointmentDto, ResultString
} from "@/generated/openapi";

class AppointmentService {

    public getAppointments(searchTerm?: string, counselingCenterId?: string, counselingCenterAreas?: string, advisorId?: string, type?: AppointmentType, clientId?: string, timeFrom?: string, timeUntil?: string, cancelled?: boolean, notCancelledByAdvisor?: boolean, limit?: number, offset?: number, sortString?: string): Promise<ResultAppointmentDto> {
        return defaultApi.findAppointments(searchTerm, counselingCenterId, counselingCenterAreas, advisorId, type, clientId, timeFrom, timeUntil, cancelled, notCancelledByAdvisor, limit, offset, sortString).then(response => {
            if (response.data) {
                return response.data
            }
            return {} as ResultAppointmentDto
        }).catch((err) => {
            throw err;
        });
    }


    public getAppointmentsPublic(limit?: number, offset?: number, sortString?: string, deleted?: boolean, counselingCenterAreas?: string): Promise<ResultAppointmentDto> {
        return publicApi.findAppointments(undefined, undefined, counselingCenterAreas, undefined, undefined, undefined, undefined, undefined, deleted, undefined, limit, offset, sortString).then(response => {
            if (response.data) {
                return response.data
            }
            return {} as ResultAppointmentDto
        }).catch((err) => {
            throw err;
        });
    }

    public createAppointment(appoint: CreateAppointmentDto): Promise<AppointmentDto> {
        return defaultApi.createAppointment(appoint).then(resp => {
            return resp.data
        }).catch(err => {
            throw err;
        })
    }

    public cancelAppointment(id: string, appoint: CancelAppointmentDto): Promise<void> {
        return publicApi.cancelAppointment(id, appoint).then(resp => {
            return resp.data
        }).catch(err => {
            throw err;
        })
    }

    public cancelAdminAppointment(id: string, appoint: CancelAppointmentDto): Promise<void> {
      return defaultApi.cancelAppointment(id, appoint).then(resp => {
          return resp.data
      }).catch(err => {
          throw err;
      })
  }

    public updateAppointment(id: string, appoint: AppointmentDto): Promise<AppointmentDto> {
        return defaultApi.updateAppointment(id, appoint).then(resp => {
            return resp.data
        }).catch(err => {
            throw err;
        })
    }

    public getAdvisors(): Promise<ResultString> {
        return defaultApi.findAdvisors().then((resp) => {
            return resp.data
        }).catch((err) => {
            throw err;
        });
    }

    public getAppointment(id: string): Promise<AppointmentDto> {
        return defaultApi.getAppointment(id, getLanguageHeaders()).then((resp) => {
            return resp.data
        }).catch((err) => {
            throw err;
        });
    }

    public getAppointmentMeetingUrl(id: string, appointment: AppointmentDto): Promise<string> {
        return defaultApi.getAppointmentMeetingUrl(id, appointment, getLanguageHeaders()).then((resp) => {
            return resp.data
        }).catch((err) => {
            throw err;
        });
    }

    public getAppointmentMeetingUrlForClient(id: string, appointment: AppointmentDto): Promise<string> {
        return publicApi.getAppointmentMeetingUrl(id, appointment, getLanguageHeaders()).then((resp) => {
            return resp.data
        }).catch((err) => {
            throw err;
        });
    }

    public deleteAppointment(id: string): Promise<void> {
        return defaultApi.deleteAppointment(id).then((_) => {
            return
        }).catch(err => {
            throw err;
        })
    }

}




const appointmentService = new AppointmentService()
export default appointmentService
